import { FieldsRow } from "features/admin/Products/types";
import { ObjectType } from "features/types";

export const createImageObjects = (data: any) => {
  let images = [];
  let updatedImages = [];
  for (let idx = 0; idx < 10; idx++) {
    const prop = `image_file${idx}`;
    if (data[prop] && data[prop].file) {
      images.push(data[prop].file);
      updatedImages.push({
        index: idx,
        name: data[prop].file.name,
        is_main_image: data[prop].is_main_image,
      });
    } else if (!data[prop] || data[prop].image === undefined) {
      updatedImages.push({
        index: idx,
        name: undefined,
        is_main_image: false,
      });
    }
  }

  return { images, updatedImages };
};

const createExtasArray = (data: any) => {
  let extras: any[] = [];
  let extrasImages: any[] = [];
  let updatedExtrasImages: any[] = [];
  for (let idx = 0; idx <= data.extras_count; idx++) {
    const imageKey = `extras_image_file_${idx}`;
    const descriptionKey = `extras_description_text_${idx}`;
    const titleKey = `extras_title_${idx}`;
    if (data.hasOwnProperty(imageKey) && data.hasOwnProperty(titleKey) && data.hasOwnProperty(descriptionKey)) {
      extras.push({
        index: idx,
        title: data[titleKey],
        text: data[descriptionKey],
      });

      if (data[imageKey].file) {
        extrasImages.push(data[imageKey].file);
        updatedExtrasImages.push({
          index: idx,
          name: data[imageKey].file.name,
          is_main_image: data[imageKey].is_main_image,
        });
      } else if (data[imageKey].image === undefined) {
        updatedExtrasImages.push({
          index: idx,
          name: undefined,
          is_main_image: data[imageKey].is_main_image,
        });
      }
    }
  }

  return { extras, extrasImages, updatedExtrasImages };
};

const createInnerItemsArray = (data: any) => {
  let innerItems: any[] = [];
  let innerItemsImages: any[] = [];
  let updatedInnerItemsImages: any[] = [];
  for (let idx = 0; idx <= data.mutisplit_count; idx++) {
    const imageKey = `inner_item_image_file_${idx}`;
    const modelKey = `inner_item_model_${idx}`;
    const priceKey = `inner_item_price_${idx}`;
    const priceEurKey = `inner_item_price_eur_${idx}`;
    const typeKey = `inner_item_type_${idx}`;

    if (
      data.hasOwnProperty(imageKey) &&
      data.hasOwnProperty(modelKey) &&
      data.hasOwnProperty(priceKey) &&
      data.hasOwnProperty(typeKey)
    ) {
      innerItems.push({
        index: idx,
        model: data[modelKey],
        price: data[priceKey],
        price_eur: data[priceEurKey],
        type: data[typeKey],
      });

      if (data[imageKey].file) {
        innerItemsImages.push(data[imageKey].file);
        updatedInnerItemsImages.push({
          index: idx,
          name: data[imageKey].file.name,
          is_main_image: data[imageKey].is_main_image,
        });
      } else if (data[imageKey].image === undefined) {
        updatedInnerItemsImages.push({
          index: idx,
          name: undefined,
          is_main_image: data[imageKey].is_main_image,
        });
      }
    }
  }

  return { innerItems, innerItemsImages, updatedInnerItemsImages };
};

export const createProduct = (data: any, allTags: any[], type: string) => {
  if (type === "product") {
    return createAirConditioner(data, allTags);
  } else {
    return createMultisplit(data, allTags);
  }
};

const createAirConditioner = (data: any, allTags: any[]) => {
  let productTags = allTags.filter((item) => {
    return data.tags && data.tags.find((tag: string) => item.title === tag);
  });
  let { images, updatedImages } = createImageObjects(data);
  let { extras, extrasImages, updatedExtrasImages } = createExtasArray(data);
  const productTitle = `${data.type} климатик ${data.brand} ${data.model}, ${data.power_btu}, Клас ${data.energy_class_cooling}`;
  const productAlias = transliterate(productTitle);
  const fields = {
    description: {
      text: data.description_text,
      energy_class_cooling: data.energy_class_cooling,
      energy_class_heating: data.energy_class_heating,
      quadrature: data.quadrature,
      type: data.type,
      free_mounting: data.free_mounting,
      outbound_power_cooling: data.outbound_power_cooling,
      outbound_power_heating: data.outbound_power_heating,
      en_consumption_cooling: data.en_consumption_cooling,
      en_consumption_heating: data.en_consumption_heating,
    },
    tech_specs: {
      data: {
        common_specs: {
          title: "Обща техническа информация",
          data: {
            type: {
              value: data.type,
              title: "Тип",
            },
            quadrature: {
              value: data.quadrature,
              title: "За помещения (кв.м.)",
            },
            energy_class_cooling: {
              value: data.energy_class_cooling,
              title: "Енергиен клас охлаждане",
            },
            energy_class_heating: {
              value: data.energy_class_heating,
              title: "Енергиен клас отопление",
            },
            power_btu: {
              value: data.power_btu,
              title: "Мощност BTU",
            },
            outbound_power_cooling: {
              value: data.outbound_power_cooling,
              title: "Отдавана мощност (охлаждане) (kW)",
            },
            outbound_power_heating: {
              value: data.outbound_power_heating,
              title: "Отдавана мощност (отопление) (kW)",
            },
            en_consumption_cooling: {
              value: data.en_consumption_cooling,
              title: "Консумирана мощност (охлаждане) (kW)",
            },
            en_consumption_heating: {
              value: data.en_consumption_heating,
              title: "Консумирана мощност (отопление) (kW)",
            },
            cubature: {
              value: data.cubature,
              title: "За помещения (куб.м.)",
            },
            eer: {
              value: data.eer,
              title: "EER (хладилен коефициент, охлаждане)",
            },
            seer: {
              value: data.seer,
              title: "SEER (сезонна ефективност в режим на охлаждане)",
            },
            cop: {
              value: data.cop,
              title: "COP (коефициент на трансформация, отопление)",
            },
            scop: {
              value: data.scop,
              title: "SCOP (сезонна ефективност в режим на отопление)",
            },
            power_supply_voltage: {
              value: data.power_supply_voltage,
              title: "Захранващо напрежение (V)",
            },
            work_amplitude_heating: {
              value: data.work_amplitude_heating,
              title: "Работен диапазон при отопление (°C)",
            },
            work_amplitude_cooling: {
              value: data.work_amplitude_cooling,
              title: "Работен диапазон при охлаждане (°C)",
            },
            fridge_agent: {
              value: data.fridge_agent,
              title: "Хладилен агент",
            },
            pipe_diameter: {
              value: data.pipe_diameter,
              title: "Диаметър на тръбата течност/газ (мм.)",
            },
            power_supply: {
              value: data.power_supply,
              title: "Захранване",
            },
            country_of_origin: {
              value: data.country_of_origin,
              title: "Произведен в",
            },
            waranty: {
              value: data.waranty,
              title: "Гаранция",
            },
            annual_power_consump_cooling: {
              value: data.annual_power_consump_cooling,
              title: "Годишен разход на електроенергия (охлаждане) (kW)",
            },
            annual_power_consump_heating: {
              value: data.annual_power_consump_heating,
              title: "Годишен разход на електроенергия (отопление) (kW)",
            },
            apf: {
              value: data.apf,
              title: "APF (годишна ефективност)",
            },
            heating_power_low_temp: {
              value: data.heating_power_low_temp,
              title: "Отоплителна мощност при ниска външна температура (kW)",
            },
          },
        },
        internal_specs: {
          data: {
            noise: {
              title: "Ниво на шум (dB)",
              value: data.internal_specs_noise,
            },
            dimensions: {
              title: "Размери Ш x В x Д (мм)",
              value: data.internal_specs_dimensions,
            },
            weight: {
              title: "Тегло (кг.)",
              value: data.internal_specs_weight,
            },
          },
          title: "Характеристики на вътрешното тяло",
        },
        external_specs: {
          data: {
            noise: {
              title: "Ниво на шум (dB)",
              value: data.external_specs_noise,
            },
            dimensions: {
              title: "Размери Ш x В x Д (мм)",
              value: data.external_specs_dimensions,
            },
            weight: {
              title: "Тегло (кг.)",
              value: data.external_specs_weight,
            },
            powercort: {
              title: "Захранващ кабел",
              value: data.external_specs_powercort,
            },
            electric_heater: {
              title: "Ел. нагревател",
              value: data.external_specs_electric_heater,
            },
            stands_distance: {
              title: "Разстояние между стойките (мм)",
              value: data.external_specs_stands_distance,
            },
          },
          title: "Характеристики на външното тяло",
        },
      },
      title: "Технически данни",
    },
    title: productTitle,
    alias: data.alias ?? productAlias,
    titleMeta: data.titleMeta,
    tagsMeta: data.tagsMeta,
    descriptionMeta: data.descriptionMeta,
    category: data.category,
    type: data.type,
    brand: data.brand,
    class: data.class,
    quadrature: data.quadrature,
    power_btu: data.power_btu.length === 9 ? "0" + data.power_btu : data.power_btu,
    energy_class_cooling: data.energy_class_cooling,
    energy_class_heating: data.energy_class_heating,
    price: data.price,
    price_eur: data.price_eur,
    price_promotion: data.price_promotion,
    price_promotion_eur: data.price_promotion_eur,
    favourite: data.isFavourite,
    recommended: data.isRecommended,
    newest: data.isNewest,
    advantageous: data.isAdvantageous,
    best_seller: data.isBestSeller,
    tags: productTags,
    quantity: data.quantity,
    model: data.model,
    updatedImages: updatedImages,
    objectType: ObjectType.product,
    extras,
    updatedExtrasImages,
  };

  return { fields, images, extrasImages };
};
const createMultisplit = (data: any, allTags: any[]) => {
  let type = "Мултисплит";
  let productTags = allTags.filter((item) => {
    return data.tags && data.tags.find((tag: string) => item.title === tag);
  });
  let { images, updatedImages } = createImageObjects(data);
  let { innerItems, innerItemsImages, updatedInnerItemsImages } = createInnerItemsArray(data);
  const productTitle = `${type} климатик ${data.brand} ${data.model}, ${data.power_btu}, Клас ${data.energy_class_cooling}`;
  const productAlias = transliterate(productTitle);
  const fields = {
    description: {
      text: data.description_text,
      energy_class_cooling: data.energy_class_cooling,
      energy_class_heating: data.energy_class_heating,
      quadrature: data.quadrature,
      type,
      free_mounting: data.free_mounting,
      outbound_power_cooling: data.outbound_power_cooling,
      outbound_power_heating: data.outbound_power_heating,
      en_consumption_cooling: data.en_consumption_cooling,
      en_consumption_heating: data.en_consumption_heating,
    },
    tech_specs: {
      data: {
        common_specs: {
          title: "Обща техническа информация",
          data: {
            //         type: {
            //           value: data.type,
            //           title: "Тип",
            //         },
            //         quadrature: {
            //           value: data.quadrature,
            //           title: "За помещения (кв.м.)",
            //         },
            energy_class_cooling: {
              value: data.energy_class_cooling,
              title: "Енергиен клас охлаждане",
            },
            energy_class_heating: {
              value: data.energy_class_heating,
              title: "Енергиен клас отопление",
            },
            power_btu: {
              value: data.power_btu,
              title: "Мощност BTU",
            },
            outbound_power_cooling: {
              value: data.outbound_power_cooling,
              title: "Отдавана мощност (охлаждане) (kW)",
            },
            outbound_power_heating: {
              value: data.outbound_power_heating,
              title: "Отдавана мощност (отопление) (kW)",
            },
            en_consumption_cooling: {
              value: data.en_consumption_cooling,
              title: "Консумирана мощност (охлаждане) (kW)",
            },
            en_consumption_heating: {
              value: data.en_consumption_heating,
              title: "Консумирана мощност (отопление) (kW)",
            },
            //         cubature: {
            //           value: data.cubature,
            //           title: "За помещения (куб.м.)",
            //         },
            eer: {
              value: data.eer,
              title: "EER (хладилен коефициент, охлаждане)",
            },
            seer: {
              value: data.seer,
              title: "SEER (сезонна ефективност в режим на охлаждане)",
            },
            cop: {
              value: data.cop,
              title: "COP (коефициент на трансформация, отопление)",
            },
            scop: {
              value: data.scop,
              title: "SCOP (сезонна ефективност в режим на отопление)",
            },
            power_supply_voltage: {
              value: data.power_supply_voltage,
              title: "Захранващо напрежение (V)",
            },
            work_amplitude_heating: {
              value: data.work_amplitude_heating,
              title: "Работен диапазон при отопление (°C)",
            },
            work_amplitude_cooling: {
              value: data.work_amplitude_cooling,
              title: "Работен диапазон при охлаждане (°C)",
            },
            fridge_agent: {
              value: data.fridge_agent,
              title: "Хладилен агент",
            },
            //         pipe_diameter: {
            //           value: data.pipe_diameter,
            //           title: "Диаметър на тръбата течност/газ (мм.)",
            //         },
            power_supply: {
              value: data.power_supply,
              title: "Захранване",
            },
            country_of_origin: {
              value: data.country_of_origin,
              title: "Произведен в",
            },
            waranty: {
              value: data.waranty,
              title: "Гаранция",
            },
            annual_power_consump_cooling: {
              value: data.annual_power_consump_cooling,
              title: "Годишен разход на електроенергия (охлаждане) (kW)",
            },
            annual_power_consump_heating: {
              value: data.annual_power_consump_heating,
              title: "Годишен разход на електроенергия (отопление) (kW)",
            },
            apf: {
              value: data.apf,
              title: "APF (годишна ефективност)",
            },
            heating_power_low_temp: {
              value: data.heating_power_low_temp,
              title: "Отоплителна мощност при ниска външна температура (kW)",
            },
          },
          //       },
        },
        //     internal_specs: {
        //       data: {
        //         noise: {
        //           title: "Ниво на шум (dB)",
        //           value: data.internal_specs_noise,
        //         },
        //         dimensions: {
        //           title: "Размери Ш x В x Д (мм)",
        //           value: data.internal_specs_dimensions,
        //         },
        //         weight: {
        //           title: "Тегло (кг.)",
        //           value: data.internal_specs_weight,
        //         },
        //       },
        //       title: "Характеристики на вътрешното тяло",
        //     },
        //     external_specs: {
        //       data: {
        //         noise: {
        //           title: "Ниво на шум (dB)",
        //           value: data.external_specs_noise,
        //         },
        //         dimensions: {
        //           title: "Размери Ш x В x Д (мм)",
        //           value: data.external_specs_dimensions,
        //         },
        //         weight: {
        //           title: "Тегло (кг.)",
        //           value: data.external_specs_weight,
        //         },
        //         powercort: {
        //           title: "Захранващ кабел",
        //           value: data.external_specs_powercort,
        //         },
        //         electric_heater: {
        //           title: "Ел. нагревател",
        //           value: data.external_specs_electric_heater,
        //         },
        //         stands_distance: {
        //           title: "Разстояние между стойките (мм)",
        //           value: data.external_specs_stands_distance,
        //         },
        //       },
        //       title: "Характеристики на външното тяло",
        //     },
      },
      //   title: "Технически данни",
    },
    title: productTitle,
    alias: data.alias ?? productAlias,
    titleMeta: data.titleMeta,
    tagsMeta: data.tagsMeta,
    descriptionMeta: data.descriptionMeta,
    category: data.category,
    type,
    brand: data.brand,
    // class: data.class,
    quadrature: "-1",
    power_btu: data.power_btu.length === 9 ? "0" + data.power_btu : data.power_btu,
    energy_class_cooling: data.energy_class_cooling,
    energy_class_heating: data.energy_class_heating,
    price: data.price,
    price_eur: data.price_eur,
    price_promotion: data.price_promotion,
    price_promotion_eur: data.price_promotion_eur,
    // favourite: data.isFavourite,
    // isRecommended: data.isRecommended,
    // newest: data.isNewest,
    // advantageous: data.isAdvantageous,
    // best_seller: data.isBestSeller,
    tags: productTags,
    quantity: data.quantity,
    model: data.model,
    updatedImages: updatedImages,
    objectType: ObjectType.product,
    internal_bodies: innerItems,
    internal_bodies_updated_images: updatedInnerItemsImages,
  };

  return { fields, images, internal_bodies_images: innerItemsImages };
};
export const transliterate = (word: any) => {
  let answer = "";
  let a: any = {};

  a["Ё"] = "YO";
  a["Й"] = "I";
  a["Ц"] = "TS";
  a["У"] = "U";
  a["К"] = "K";
  a["Е"] = "E";
  a["Н"] = "N";
  a["Г"] = "G";
  a["Ш"] = "SH";
  a["Щ"] = "SCH";
  a["З"] = "Z";
  a["Х"] = "H";
  a["Ъ"] = "'";
  a["ё"] = "yo";
  a["й"] = "i";
  a["ц"] = "ts";
  a["у"] = "u";
  a["к"] = "k";
  a["е"] = "e";
  a["н"] = "n";
  a["г"] = "g";
  a["ш"] = "sh";
  a["щ"] = "sch";
  a["з"] = "z";
  a["х"] = "h";
  a["ъ"] = "'";
  a["Ф"] = "F";
  a["Ы"] = "I";
  a["В"] = "V";
  a["А"] = "a";
  a["П"] = "P";
  a["Р"] = "R";
  a["О"] = "O";
  a["Л"] = "L";
  a["Д"] = "D";
  a["Ж"] = "ZH";
  a["Э"] = "E";
  a["ф"] = "f";
  a["ы"] = "i";
  a["в"] = "v";
  a["а"] = "a";
  a["п"] = "p";
  a["р"] = "r";
  a["о"] = "o";
  a["л"] = "l";
  a["д"] = "d";
  a["ж"] = "zh";
  a["э"] = "e";
  a["Я"] = "Ya";
  a["Ч"] = "CH";
  a["С"] = "S";
  a["М"] = "M";
  a["И"] = "I";
  a["Т"] = "T";
  a["Ь"] = "'";
  a["Б"] = "B";
  a["Ю"] = "YU";
  a["я"] = "ya";
  a["ч"] = "ch";
  a["с"] = "s";
  a["м"] = "m";
  a["и"] = "i";
  a["т"] = "t";
  a["ь"] = "'";
  a["б"] = "b";
  a["ю"] = "yu";
  a["/"] = "";
  a["."] = "";

  for (var i in word) {
    if (word.hasOwnProperty(i)) {
      if (a[word[i]] === undefined) {
        answer += word[i];
      } else {
        answer += a[word[i]];
      }
    }
  }

  var re = /,?[ ]/g;
  var subst = "-";

  var result = answer.replace(re, subst);
  return result.toLowerCase();
};
